module.exports = __webpack_public_path__ + "static/media/scenario-3.7eb70609.png";